<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="jump_to_top_4">Heidis Lehr- und Wanderjahre</h1>
<p class="bildabsatz"><span class="bilderrahmen"><img alt="Bild: 054_Heidi_003.jpg" class="bild_ohne_rahmen" src="media/054_Heidi_003.jpg" title=""/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec000004.vue?05d6964a